import { gql, useApolloClient, useMutation, } from '@apollo/client';
import { OCCUPANT_FIELDS } from 'common-app/api/fragments/bailleurs-participant';
export const OCCUPANT_CREATE = gql `
    ${OCCUPANT_FIELDS}
    mutation createOccupant($dossierId: Long) {
      create_occupant(dossierId: $dossierId) {
        ...OccupantFields
      }
    }
  `;
export const useOccupantCreateMutation = (options) => useMutation(OCCUPANT_CREATE, options);
export const useOccupantCreateMutationPromise = () => {
    const client = useApolloClient();
    return (variables, options) => client.mutate(Object.assign(Object.assign({}, options), { mutation: OCCUPANT_CREATE, variables }));
};
